.root {
  text-align: center;
}
